module.exports = __webpack_public_path__ + "static/img/100_fot_contract.2cc8447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_fot_contract.jpg
// module id = CdCy
// module chunks = 1